import { render, staticRenderFns } from "./color-widget.vue?vue&type=template&id=ab900f68&scoped=true&"
import script from "./color-widget.vue?vue&type=script&lang=js&"
export * from "./color-widget.vue?vue&type=script&lang=js&"
import style0 from "./color-widget.vue?vue&type=style&index=0&id=ab900f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab900f68",
  null
  
)

export default component.exports